/** Tek yerden marka adı (navbar, footer; `public/index.html` başlığı ile eşleştirin). */
export const SITE_NAME = 'Eskişehir Davetiye';
